import { AddonActionRadioButtons } from 'components/shared/ButtonsGroup/AddonActionRadioButtons';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSidePanelAddonActionOrDefault, getTradeConfirmation } from 'state/selectors';
import { AppState } from 'state/state.model';
import { updateSidePanelMetadata } from 'state/uiPanelState/sidePanelUi/sidePanelUi.action';
import { QuoteWorkspaceType } from 'state/workspaces/model';

export interface AddonActionSwitchProps {
  e2e?: string;
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export const AddonActionSwitch: FC<AddonActionSwitchProps> = ({ e2e, tabId, workspaceType }) => {
  const dispatch = useDispatch();
  const addonAction = useSelector((state: AppState) => getSidePanelAddonActionOrDefault(state, tabId, workspaceType));
  const { isTrading } = useSelector((state: AppState) => getTradeConfirmation(state, workspaceType, tabId));
  return (
    <AddonActionRadioButtons
      className="w-100"
      value={addonAction ?? 'Increase'}
      onSelect={addonAction => dispatch(updateSidePanelMetadata(tabId, { addonAction: addonAction }))}
      e2e={e2e ?? ''}
      isDisabled={isTrading}
    />
  );
};
